// extracted by mini-css-extract-plugin
module.exports = {"loading__animate":"styles_loading__animate__3NBbE","shimmer":"styles_shimmer__2Iglu","fullView":"styles_fullView__12AQu"};